/**
 * Route copy for `src/routes/reports` (keys: `routes.reports.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  reportsCenterPage: {
    whiteLabelReportsFeature: 'White-label reports',
    competitiveBenchmarkFeature: 'Competitive benchmark',
    couldNotLoadTheReports: 'Could not load the reports.',
    reportDefined: 'Report defined',
    theCreationFailed: 'The creation failed.',
    renderingFailed: 'Rendering failed.',
    theFormatExportFailed: 'The {{format}} export failed.',
    reportDeleted: 'Report deleted',
    deletionFailed: 'Deletion failed.',
    newReport: 'New report',
    title: 'Title',
    monthlyReportOctober: 'Monthly report — October',
    brandWhiteLabelHeader: 'Brand (white-label header)',
    nameShownInTheExportedReport: 'Name shown in the exported report\'s header',
    sections: 'Sections',
    periodDays: 'Period (days)',
    days: 'days',
    platforms: 'Platforms',
    emptyAll: 'Empty = all',
    saving: 'Saving…',
    defineTheReport: 'Define the report',
    readOnlyRoleDefiningReportsIs: 'Read-only role: defining reports is reserved for authorized roles.',
    myReports: 'My reports',
    noReportDefined: 'No report defined',
    createAWhiteLabelReportOn: 'Create a white-label report on the left to be able to generate and export it.',
    lengthSectionS: '{{length}} section(s)',
    rendering: 'Rendering…',
    preview: 'Preview',
    del: 'Del.',
    previewTitle: 'Preview — {{title}}',
    notAvailable: 'not available',
    couldNotLoadTheBenchmark: 'Could not load the benchmark.',
    competitorSaved: 'Competitor saved',
    savingFailed: 'Saving failed.',
    competitorRemoved: 'Competitor removed',
    trackedCompetitors: 'Tracked competitors',
    name: 'Name',
    competitorA: 'Competitor A',
    platform: 'Platform',
    accountHandle: 'Account (@handle)',
    competitor: '@competitor',
    adding: 'Adding…',
    track: 'Track',
    readOnlyRoleManagingCompetitorsIs: 'Read-only role: managing competitors is reserved for authorized roles.',
    removeName: 'Remove {{name}}',
    comparison: 'Comparison',
    noComparisonData: 'No comparison data',
    saveCompetitorsAboveTheComparisonShows: 'Save competitors above. The comparison shows your brand against them, metric by metric, with honest per-platform coverage.',
    entity: 'Entity',
    coverage: 'Coverage',
    you: 'You',
    metricNotExposedByThePlatform: 'metric not exposed by the platform',
    reportsBenchmark: 'Reports & Benchmark',
    buildWhiteLabelReportsSectionsPeriod: 'Build white-label reports (sections, period, platforms) and compare your brand with your competitors — with honest per-platform data coverage.',
    reports: 'Reports',
    competitiveBenchmark: 'Competitive benchmark',
    reportsAndBenchmarkSections: 'Reports and benchmark sections',
  },
};

export default en;
